import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { routes } from '@libs/utils';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OnboardingVideoComponent } from 'libs/onboarding/src/lib/onboarding-modal/steps/onboarding-video/onboarding-video.component';
import { SiteSetupComponentService, StepNumberEnum } from '../../site-setup/site-setup.component.service';
import { siteSetupVideos } from '../../site-setup-videos';

@Component({
  selector: 'lib-software-license-video',
  imports: [CommonModule, TranslateModule, OnboardingVideoComponent],
  templateUrl: './software-license-video.component.html',
  styleUrl: './software-license-video.component.scss',
})
export class SoftwareLicenseVideoComponent {
  private readonly service = inject(SiteSetupComponentService);
  private readonly router = inject(Router);
  public vm = this.service.viewModel;

  public routes = routes;
  public StepNumberEnum = StepNumberEnum;
  public licenseVideo = siteSetupVideos[1];

  public next(): void {
    this.service.setContractActiveStep({
      step: StepNumberEnum.SoftwareLicenseAgreement,
    });
    this.service.setActiveStep(StepNumberEnum.SoftwareLicenseAgreement);
    this.router.navigate([routes.setup, routes.softwareLicense, routes.softwareLicenseAgreement]);
  }
}
